{
  "testRamp": {
    "layout": "Affichage",
    "iterativeMode": "Mode itératif",
    "showCurvedLines": "Lignes courbes",
    "showAircraftImages": "Afficher images appareil",
    "datasetSize": "Taille des données",
    "useSpaceQuality": "Optimisation qualité espace",
    "qualityMetric": "Indicateur qualité",
    "optimizationLevel": "Niveau d'optimisation",
    "safetyBufferMode": "Mode tampon de sécurité",
    "priorityFirstSorting": "Tri par priorité",
    "showAreas": "Voir les zones",
    "showObstacles": "Voir les obstacles",
    "legends": {
      "obstacles": "Obstacles",
      "noGoZones": "Zones interdites"
    }
  }
}
